module.controller('ssoRedirectCtrl', ['$http', 'baseURI', '$state', '$rootScope', '$scope', '$stateParams', 'LimitsService', 'Session', 'cacheService', 'authService', 'brandService', '$q', 'localStorageService', 'Transform', '$timeout', function ($http, baseURI, $state, $rootScope, $scope, $stateParams, LimitsService, Session, cacheService, authService, brandService, $q, localStorageService, Transform, $timeout) {
  $scope.text = 'Redirecting';
  $scope.loading = true;
  $scope.displayMessageText = 'Sorry, we were unable to log you in. Please try again in a few minutes.';

  var handleError = function (error){
    $scope.loading = false;
    $scope.displayMessage = true;
  };

  authService.ssoLogin($stateParams.token, $scope.brand.name, function(error, response){
    if(!response){
      handleError(error);
    } else {
      cacheService.clear('all');
      $scope.displayMessage = false;

      $q.all([
        authService.checkStatus(),
        authService.getFeatureAccess(),
        LimitsService.update()
      ]).then(function(results){

        // set status and feature access
        authService.setStatusSession(results[0].data);
        authService.setFeatureAccessSession(results[1].data);

        authService.injectUserToDashboard();

      }).catch(function(err){
        handleError(err);
      });
    }
  });

}]);
